import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatTimeTo12Hour } from "./SlaCategorystore/useSlaCategoryStore";

export const ExportSlaCategory = ({ slaCategoryData = [] }) => {
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SLA Categories");
    const boldFont = { bold: true };

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `SLA Category Details Generated on: ${formattedDate}, ${formattedTime}`;

    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    worksheet.addRow(["", "", "SLA Category List", ""]);
    worksheet.mergeCells(2, 2, 2, 5);
    worksheet.getCell(2, 2).value = "SLA Category List";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };


    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Category Name",
      "Duration (In Hr)",
      "Start Time",
      "End Time",
      "Status",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };

      if (colNumber >= 1 && colNumber <= 6) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "003366" },
          bgColor: { argb: "FFFFFFFF" },
        };
      }
    });

    slaCategoryData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.categoryName || "N/A",
          item.durationInHr ?? "N/A",
          formatTimeTo12Hour(item.startTime),
          formatTimeTo12Hour(item.endTime),
          item.isActive === true ? "Active" : "Inactive",
        ])
        .eachCell({ includeEmpty: true }, (cell) => {
          cell.alignment = { horizontal: "center" };
        });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
    ];

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "SlaCategoryDetails.xlsx";
      anchor.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  // const exportToPDF = () => {
  //   const doc = new jsPDF();
  //   const currentDate = new Date();
  //   const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
  //   const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
  //   const downloadDateTime = `SLA Category Report Generated on: ${formattedDate} ${formattedTime}`;

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(16);
  //   doc.text("SLA Category List", 14, 20);
  //   doc.setFontSize(12);
  //   doc.text(downloadDateTime, 14, 30);

  //   const tableColumn = [
  //     "S.No",
  //     "Category Name",
  //     "Duration (In Hr)",
  //     "Start Time",
  //     "End Time",
  //     "Status",
  //   ];
  //   const tableRows = slaCategoryData.map((row, index) => [
  //     index + 1,
  //     row.categoryName || "N/A",
  //     row.durationInHr ?? "N/A",
  //     formatTimeTo12Hour(row.startTime),
  //     formatTimeTo12Hour(row.endTime),
  //     row.isActive === true ? "Active" : "Inactive",
  //   ]);

  //   autoTable(doc, {
  //     startY: 40,
  //     head: [tableColumn],
  //     body: tableRows,
  //     theme: "grid",
  //     styles: {
  //       fontSize: 8,
  //       cellPadding: 2,
  //       overflow: "linebreak",
  //       valign: "middle",
  //     },
  //     headStyles: {
  //       fillColor: [0, 51, 102],
  //       textColor: [255, 255, 255],
  //       fontStyle: "bold",
  //     },
  //     bodyStyles: {
  //       fontSize: 8,
  //       halign: "left",
  //     },
  //   });
  //   doc.save("SlaCategoryDetails.pdf");
  // };

  const exportToPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `SLA Category Report Generated on: ${formattedDate} ${formattedTime}`;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("SLA Category List", 14, 20);

    doc.setFontSize(12);
    doc.text(downloadDateTime, 14, 30);

    const tableColumn = [
      "S.No",
      "Category Name",
      "Duration (In Hr)",
      "Start Time",
      "End Time",
      "Status",
    ];

    const tableRows = slaCategoryData.map((row, index) => [
      index + 1,
      row.categoryName || "N/A",
      row.durationInHr ?? "N/A",
      formatTimeTo12Hour(row.startTime),
      formatTimeTo12Hour(row.endTime),
      row.isActive === true ? "Active" : "Inactive",
    ]);

    autoTable(doc, {
      startY: 40,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: "linebreak",
        valign: "middle",
      },

      headStyles: {
        fillColor: [0, 51, 102],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
      },

      bodyStyles: {
        fontSize: 8,
        halign: "center",
        valign: "middle",
      },

      columnStyles: {
        0: { cellWidth: 15 }, // S.No
        1: { cellWidth: 115 }, // Category Name
        2: { cellWidth: 35 }, // Duration
        3: { cellWidth: 35 }, // Start Time
        4: { cellWidth: 35 }, // End Time
        5: { cellWidth: 30 }, // Status
      },
    });

    doc.save("SlaCategoryDetails.pdf");
  };

  return (
    <>
      <button type="button" onClick={exportToExcel} className="button-container ms-3">
        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
      </button>
      <button type="button" onClick={exportToPDF} className="button-container ms-3">
        <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
      </button>
    </>
  );
};
